module.exports = __webpack_public_path__ + "img/f3e991376a1a3d9e5bc706b0dc2c5b7f.png";